<template>
  <!-- Table -->
  <v-data-table
    v-model="selected"
    :headers="tableHeaders"
    :items="query.data"
    :server-items-length="query.length"
    :options.sync="query.options"
    :loading="query.loading"
    item-key="product._id"
    show-select
    dense
    class="elevation-2 rounded-lg grow text-truncate"
    style="border-color: red !important"
  >
    <!-- Table Header -->
    <template v-slot:top>
      <v-row no-gutters class="pa-3">
        <span class="text-h6">Reported Product</span>
        <v-spacer></v-spacer>

        <!-- Option Button -->
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!selected.length"
              :dark="!!selected.length"
              small
              depressed
              class="rounded-xl lighten-1"
              color="cyan"
              v-on="on"
              v-bind="attrs"
              >Option</v-btn
            >
          </template>

          <!-- Option Menu -->
          <v-list dense>
            <v-list-item disabled>
              <v-list-item-title>
                <v-icon small left>mdi-checkbox-marked-circle</v-icon>
                Confirm
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="updateMany(false)">
              <v-list-item-title>
                <v-icon small left>mdi-close-circle</v-icon>
                Ignore
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn small depressed disabled class="rounded-xl cyan lighten-1 ml-1"
          >Filter</v-btn
        >
      </v-row>
    </template>

    <!-- Price -->
    <template v-slot:item.price="{ item: { price } }">
      {{ price.toLocaleString() }}
    </template>

    <!-- ID -->
    <template v-slot:item.product._id="{ item: { product } }">
      <a :href="`/${product.type}/p/${product._id}`" target="_blank">
        {{ product._id }}
      </a>
    </template>

    <!-- Actions -->
    <template v-slot:item.actions="{ item }">
      <v-icon small @click="showReportMessage(item)" :disabled="query.loading">
        mdi-comment-question
      </v-icon>
      <v-btn
        small
        icon
        @click="updateOne(item, true)"
        :disabled="query.loading"
      >
        <v-icon small> mdi-checkbox-marked-circle </v-icon>
      </v-btn>
      <v-icon small @click="updateOne(item, false)" :disabled="query.loading">
        mdi-close-circle
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import admin from "../../../services/admin";
import api from "../../../services/api";

export default {
  data() {
    return {
      query: {
        data: [],
        length: 0,
        options: null,
        loading: false,
      },
      tableHeaders: [
        { text: "Product Name", value: "product.title", sortable: false },
        { text: "Type", value: "product.type", sortable: false },
        { text: "Ban Request", value: "reportCount", sortable: false },
        { text: "ID", value: "product._id", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      selected: [],
    };
  },
  mounted() {
    // this.fetchData();
  },
  methods: {
    async fetchData() {
      // Call API
      this.query.loading = true;
      let { itemsPerPage, page } = this.query.options;
      let params = {
        count: this.query.length == 0,
        size: itemsPerPage,
        page,
      };
      let result = await admin.getReportedProduct(params);
      this.query.data = result.reports;
      if (result.amount) this.query.length = result.amount;
      this.query.loading = false;
    },
    async updateMany(value) {
      const data = this.selected.map(({product: {_id}}) => ({
        _id,
        confirm: value,
      }));

      let { success, msg } = await admin.updateReportedProduct(data);
      if (!success) return api.makeAlert(msg, "error");
      api.makeAlert("Saved update.", "success");

      // Clear checkbox
      this.selected = [];
      this.fetchData();
    },
    async updateOne(item, value) {
      const _id = item.product._id;
      const data = [{ _id, confirm: value }];
      if (value) {
        let feedback = prompt("Give a short feedback for this action!");
        if (!feedback) return api.makeAlert("Cancel this action.", "secondary");
        data[0].feedback = feedback;
      }

      let { success, msg } = await admin.updateReportedProduct(data);
      if (!success) return api.makeAlert(msg, "error");
      api.makeAlert("Saved update.", "success");
      this.fetchData();
    },
    showReportMessage(item) {
      let text = "REPORT MESSAGE\n";
      for (let i in item.message) {
        text += `${parseInt(i) + 1}. ${item.message[i]}\n`;
      }
      alert(text);
    }
  },
  watch: {
    "query.options": function () {


      this.fetchData();
    },
  },
};
</script>

<style>
</style>